__webpack_require__.p = "/landing-page-furniture-website/";